export default {
  props: {
    prefix: {
      type: String,
      default: ""
    },
    heroBlock: {
      type: Object,
      default () {
        return {
          prefix: "",
          title: "",
          content: "",
          backgroundImage: null
        }
      }
    },
    breadcrumbs: {
      type: Array,
      default () {
        return []
      }
    },
    contentBlocks: {
      type: Array,
      default () {
        return []
      }
    },
    accordionBlocks: {
      type: Array,
      default () {
        return []
      }
    },
    displayImagesInNavigationBlocks: {
      type: Boolean,
      default: false
    },
    accordionsHeading: {
      type: String,
      default: ""
    }
  },
  computed: {
    threshold () {
      return this.$root.currentSizeLte("sm") ? 100 : 150
    }
  }
}
